import { AlertTriangle } from "lucide-react"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"

interface DeleteAlfredClientDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  clientId: string
  onConfirm: () => void
  isLoading?: boolean
}

export function DeleteAlfredClientDialog({
  open,
  onOpenChange,
  clientId,
  onConfirm,
  isLoading = false,
}: DeleteAlfredClientDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="bg-card border-border max-w-[400px]">
        <AlertDialogHeader>
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-destructive/20 flex items-center justify-center">
              <AlertTriangle className="h-5 w-5 text-destructive" />
            </div>
            <div className="min-w-0 flex-1">
              <AlertDialogTitle className="text-foreground">Delete client?</AlertDialogTitle>
              <AlertDialogDescription className="text-muted-foreground mt-2">
                This will permanently delete{" "}
                <span className="break-all font-mono text-foreground">{clientId}</span>. This action cannot be undone.
              </AlertDialogDescription>
            </div>
          </div>
        </AlertDialogHeader>
        <AlertDialogFooter className="mt-2">
          <AlertDialogCancel
            disabled={isLoading}
            className="bg-secondary border-input text-muted-foreground hover:bg-secondary/80 hover:text-foreground"
          >
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault()
              onConfirm()
            }}
            disabled={isLoading}
            className="bg-destructive hover:bg-destructive/90 text-destructive-foreground"
          >
            {isLoading ? "Deleting..." : "Delete"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
